<div
  class="section-container"
  [style.backgroundImage]="'url(' + data?.imagePath + ')'"
  id="home"
>
  <!-- <img [src]="data?.imagePath" class="w-100"/> -->
  <div class="descriptions">
    <div class="title">
      {{ data?.text }}
    </div>
  </div>
</div>
